import React from 'react';
import Box from '@mui/material/Box';

const TextMedium = ({
  children = '',
  color = "black",
  fontSize = 17,
  fontWeight,
  align,
  onPress,
  ...props
}) => {

  const styles = {
    text: {
      fontSize: fontSize,
      color: color,
      fontWeight: fontWeight,
      fontFamily: 'Verdana',
      textAlign: align
    }
  };

  return (
    <Box style={styles.text} onClick={onPress}>
      {children}
    </Box>
  )
};

export default TextMedium;
